import { media, spacing } from '@lamimed/pantheon';
import styled, { css } from 'styled-components';

const arbitrarySpacingNumber = '7rem';

export const Wrapper = styled.div`
  position: relative;
  margin-bottom: calc(${arbitrarySpacingNumber} + ${spacing.xlarge});

  ${media.greaterThan('tablet')`
    margin-bottom: calc(${arbitrarySpacingNumber} + ${spacing.xxlarge});
  `}
`;

interface FadeProps {
  open?: boolean;
}

export const Fade = styled.div<FadeProps>`
  width: 100%;
  position: absolute;
  margin-top: -3rem;
  padding-left: ${spacing.medium};
  padding-right: ${spacing.medium};
  padding-top: ${spacing.large};

  ${({ open = false }) =>
    !open &&
    css`
      background: linear-gradient(
        to top,
        rgba(255, 255, 255, 1) 50%,
        rgba(255, 255, 255, 0.75) 75%,
        rgba(255, 255, 255, 0) 100%
      );
    `};

  ${media.greaterThan('tablet')`
    display: flex;
    justify-content: center;
  `};
`;
